import React from "react";
import CustomModal from "../../../../components/common/general/CustomModal/CustomModal";
import useResponsiveScreen from "../../../../hooks/useResponsiveScreen";
import { updateOtpPreference } from "../../../../services";
import TwoFactorDisable from "../../../../components/settings/TwoFactorDisable/TwoFactorDisable";
import { OTPPreference } from "./types";
import Sentry from "../../../../utils/sentry";
import { useAuth } from "../../../../hooks/useAuth";
import { getValidAccessToken } from "../../../../utils/authRefresh";

interface TwoFactorAuthDisableContainerProps {
  visible: boolean;
  onClose: () => void;
}

const TwoFactorAuthDisableContainer: React.FC<TwoFactorAuthDisableContainerProps> = ({ visible, onClose }) => {
  const { isMedium } = useResponsiveScreen();
  const { refetchMe } = useAuth();

  const handleDisableTwoFactorAuth = async () => {
    try {
      const token = await getValidAccessToken();
      await updateOtpPreference(OTPPreference.NONE, token);
      await refetchMe(); // Refetch user data to update the UI
      onClose();
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      title="Two-factor Identification Setup"
      exitFill="#000000"
      onShow={() => {}}
      ariaLabel="Two-factor Authentication Modal">
      <TwoFactorDisable onDisable={handleDisableTwoFactorAuth} />
    </CustomModal>
  );
};

export default TwoFactorAuthDisableContainer;
